import { useState, useEffect, useContext } from "react";
import { UserContext } from "App";
import { EntryTypes } from "../utils/constants";

export const useEntryForm = (initialState = {}) => {
  const CurrentUser = useContext(UserContext);
  const [formData, setFormData] = useState({
    title: "",
    amount: 0,
    description: "",
    category: "",
    entryType: "",
    user: null,
    accountingSession: null,
    beneficiaryEntity: "",
    package: null,
    accountingTherapistHourId: null,
    paymentMethod: "",
    ...initialState,
  });

  const updateFormField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    setFormData({
      title: "",
      amount: 0,
      description: "",
      category: "",
      entryType: "",
      user: null,
      accountingSession: null,
      beneficiaryEntity: "",
      package: null,
      accountingTherapistHourId: null,
      paymentMethod: "",
    });
  };

  return {
    formData,
    updateFormField,
    resetForm,
    CurrentUser,
  };
};